module.exports = __webpack_public_path__ + "static/media/new-wb-franja-app.51b64a78.svg";